if (!customElements.get('cart-toggle')) {
    class CartToggle extends HTMLElement {
        static observedAttributes = ["count"];

        connectedCallback() {
            this.elToggle = this.querySelector('[data-cart-toggle]');
            this.elCount = this.querySelector('[data-cart-count]');

            this.elToggle && this.elToggle.addEventListener('click', this.#handleClick);

            this.#render();
        }

        disconnectedCallback() {
            this.elToggle && this.elToggle.removeEventListener('click', this.#handleClick);
        }

        attributeChangedCallback() {
            this.#render();
        }

        // Runs before connectedCallback on upgrade, so the count element isn't
        // cached on that first pass and connecting renders it again.
        #render() {
            if (!this.elCount) return;

            const count = Number(this.getAttribute('count')) || 0;

            this.elCount.textContent = `${count}`;
            this.classList.toggle('has-items', count > 0);
        }

        #handleClick = (ev) => {
            // Without the drawer, the link's ?cart=open href still works.
            if (typeof window.toggleCart !== 'function') return;

            ev.preventDefault();
            window.toggleCart();
        }
    }

    customElements.define('cart-toggle', CartToggle);
}
